function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironmentBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.58,166.25s13.62-15.62,33.49-15.62c0,0,.66-12.12,14.22-14.74s16.19,9.49,16.19,9.49,10-5.32,23.48,0,10.72,20.82,10.72,20.82,38.82-1.26,45.48,5.85H198.71S202.23,163.35,229.58,166.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.13,73.64s-10.87-12.45-26.71-12.45c0,0-.53-9.67-11.34-11.76S291.16,57,291.16,57s-8-4.24-18.72,0-8.56,16.61-8.56,16.61-31-1-36.27,4.66H366.75S363.94,71.33,342.13,73.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9,116.91s6.45-7.4,15.87-7.4a7.87,7.87,0,0,1,6.73-7c6.42-1.24,7.67,4.49,7.67,4.49a14,14,0,0,1,11.12,0c6.38,2.52,5.09,9.87,5.09,9.87s18.38-.6,21.54,2.77H75.28S76.94,115.53,89.9,116.91Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.72,287.92s6.45-7.4,15.87-7.4a7.86,7.86,0,0,1,6.73-7C217.74,272.3,219,278,219,278a14,14,0,0,1,11.12,0c6.38,2.51,5.09,9.87,5.09,9.87s18.38-.6,21.54,2.77H174.1S175.76,286.54,188.72,287.92Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.84,318.11s1.94,5.12,8,13C46.67,341.37,61.47,356.3,88,370.62c46.8,25.3,76.42,67.34,76.42,67.34l27.23-86.79s-12.11-.88-29.15-13C150.87,330,137,316.58,123.14,294.76,88.86,240.85,53,229.16,53,229.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.6,310.11s-1.94,5.12-8,13c-7.86,10.26-22.66,25.19-49.14,39.51-46.8,25.3-76.42,67.34-76.42,67.34l-27.23-86.79s12.11-.88,29.15-13c11.58-8.22,25.44-21.61,39.31-43.43,34.28-53.91,70.15-65.6,70.15-65.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.78,257.76s-15.93-9.18-2.88-42.35,52.28-43.23,61.15-53.23C314.05,162.18,310.47,264.05,255.78,257.76Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.79,345.25s6.8-119.76,64.51-165c0,0-53.54,44.23-56.3,165Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.39,220.41s14.25-8.21,2.57-37.88-46.76-38.67-54.69-47.61C179.27,134.92,182.47,226,231.39,220.41Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246,293.81s-3.7-102.26-55.31-142.76c0,0,49.69,44.51,50.42,159.05,0,0,1.62.32,2.49-2.32",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,157.92c28.82-53.06,101.32-115,200.79-89.2S447.57,149.1,436.56,244.06,367.68,417.92,243,420.23,16.92,274.27,80.12,157.92Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,157.92c28.82-53.06,101.32-115,200.79-89.2S447.57,149.1,436.56,244.06,367.68,417.92,243,420.23,16.92,274.27,80.12,157.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.58,166.25s13.62-15.62,33.49-15.62c0,0,.66-12.12,14.22-14.74s16.19,9.49,16.19,9.49,10-5.32,23.48,0,10.72,20.82,10.72,20.82,38.82-1.26,45.48,5.85H198.71S202.23,163.35,229.58,166.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.58,166.25s13.62-15.62,33.49-15.62c0,0,.66-12.12,14.22-14.74s16.19,9.49,16.19,9.49,10-5.32,23.48,0,10.72,20.82,10.72,20.82,38.82-1.26,45.48,5.85H198.71S202.23,163.35,229.58,166.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.13,73.64s-10.87-12.45-26.71-12.45c0,0-.53-9.67-11.34-11.76S291.16,57,291.16,57s-8-4.24-18.72,0-8.56,16.61-8.56,16.61-31-1-36.27,4.66H366.75S363.94,71.33,342.13,73.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.13,73.64s-10.87-12.45-26.71-12.45c0,0-.53-9.67-11.34-11.76S291.16,57,291.16,57s-8-4.24-18.72,0-8.56,16.61-8.56,16.61-31-1-36.27,4.66H366.75S363.94,71.33,342.13,73.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9,116.91s6.45-7.4,15.87-7.4a7.87,7.87,0,0,1,6.73-7c6.42-1.24,7.67,4.49,7.67,4.49a14,14,0,0,1,11.12,0c6.38,2.52,5.09,9.87,5.09,9.87s18.38-.6,21.54,2.77H75.28S76.94,115.53,89.9,116.91Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,116.91s6.45-7.4,15.87-7.4a7.87,7.87,0,0,1,6.73-7c6.42-1.24,7.67,4.49,7.67,4.49a14,14,0,0,1,11.12,0c6.38,2.52,5.09,9.87,5.09,9.87s18.38-.6,21.54,2.77H75.28S76.94,115.53,89.9,116.91Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.72,287.92s6.45-7.4,15.87-7.4a7.86,7.86,0,0,1,6.73-7C217.74,272.3,219,278,219,278a14,14,0,0,1,11.12,0c6.38,2.51,5.09,9.87,5.09,9.87s18.38-.6,21.54,2.77H174.1S175.76,286.54,188.72,287.92Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.72,287.92s6.45-7.4,15.87-7.4a7.86,7.86,0,0,1,6.73-7C217.74,272.3,219,278,219,278a14,14,0,0,1,11.12,0c6.38,2.51,5.09,9.87,5.09,9.87s18.38-.6,21.54,2.77H174.1S175.76,286.54,188.72,287.92Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--wind-turbines--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.41,194.12l-.1-15.6a2.13,2.13,0,0,0-4.25,0l0,5.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.94,
    y1: 198.29,
    x2: 109.9,
    y2: 204.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.3,
    y1: 332.69,
    x2: 114.51,
    y2: 209.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.83,
    y1: 214.81,
    x2: 109.08,
    y2: 332.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,205l-45.41-9.69-2.5,3.52-1.81-.19-19.21-46a1.33,1.33,0,0,0-2.5.9l13.28,44.5,4.29.49.68,1.63L82.38,239.73a1.33,1.33,0,0,0,2,1.73l32.06-33.6-1.7-4,1.13-1.46,49.73,5.24A1.33,1.33,0,0,0,166,205Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.3,
    cy: 200.23,
    r: 1.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.22,248.05l-.08-12.35a1.68,1.68,0,0,0-3.36,0l0,4.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.68,
    y1: 251.35,
    x2: 152.65,
    y2: 255.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.92,
    y1: 357.66,
    x2: 156.3,
    y2: 260.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.6,
    y1: 264.41,
    x2: 152,
    y2: 357.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.06,256.68,161.13,249l-2,2.79-1.44-.15-15.19-36.4a1,1,0,0,0-1.37-.57,1.07,1.07,0,0,0-.61,1.28l10.51,35.2,3.39.39.54,1.29-24.1,31.28a1.05,1.05,0,0,0,1.6,1.37l25.35-26.58-1.34-3.14.89-1.16,39.34,4.14a1,1,0,0,0,1.16-.93A1.05,1.05,0,0,0,197.06,256.68Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,252.88a1,1,0,1,1-1-1A1,1,0,0,1,158,252.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.59,194.12l.1-15.6a2.13,2.13,0,0,1,4.25,0l0,5.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.06,
    y1: 198.29,
    x2: 380.1,
    y2: 204.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.7,
    y1: 332.69,
    x2: 375.49,
    y2: 209.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.17,
    y1: 214.81,
    x2: 380.92,
    y2: 332.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,205l45.41-9.69,2.5,3.52,1.81-.19,19.21-46a1.33,1.33,0,0,1,2.5.9l-13.28,44.5-4.29.49-.68,1.63,30.47,39.55a1.33,1.33,0,0,1-2,1.73l-32.06-33.6,1.7-4-1.13-1.46-49.73,5.24A1.33,1.33,0,0,1,324,205Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.7,
    cy: 200.23,
    r: 1.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.78,248.05l.08-12.35a1.68,1.68,0,0,1,3.36,0l0,4.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.32,
    y1: 251.35,
    x2: 337.35,
    y2: 255.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.08,
    y1: 357.66,
    x2: 333.7,
    y2: 260.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.4,
    y1: 264.41,
    x2: 338,
    y2: 357.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94,256.68,328.87,249l2,2.79,1.44-.15,15.19-36.4a1,1,0,0,1,1.37-.57,1.07,1.07,0,0,1,.61,1.28l-10.51,35.2-3.39.39-.54,1.29,24.1,31.28a1.05,1.05,0,0,1-1.6,1.37l-25.35-26.58,1.34-3.14-.89-1.16-39.34,4.14a1,1,0,0,1-1.16-.93A1.05,1.05,0,0,1,292.94,256.68Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,252.88a1,1,0,1,0,1-1A1,1,0,0,0,332.05,252.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hands--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.84,318.11s1.94,5.12,8,13C46.67,341.37,61.47,356.3,88,370.62c46.8,25.3,76.42,67.34,76.42,67.34l27.23-86.79s-12.11-.88-29.15-13C150.87,330,137,316.58,123.14,294.76,88.86,240.85,53,229.16,53,229.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.81,331.11C46.67,341.37,61.47,356.3,88,370.62c46.8,25.3,76.42,67.34,76.42,67.34l27.23-86.79s-12.11-.88-29.15-13c-13.95-.38-42.87,9.09-57.64,23.36C104.81,361.55,70.69,344.25,38.81,331.11Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.85,349.79s16.65,14.38,26,14.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,366.46c11.87,5.77,29.28,12.22,35.61,15.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52,298.65a126.25,126.25,0,0,0,11.35,19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.84,318.11s1.94,5.12,8,13C46.67,341.37,61.47,356.3,88,370.62c46.8,25.3,76.42,67.34,76.42,67.34l27.23-86.79s-12.11-.88-29.15-13C150.87,330,137,316.58,123.14,294.76,88.86,240.85,53,229.16,53,229.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.6,310.11s-1.94,5.12-8,13c-7.86,10.26-22.66,25.19-49.14,39.51-46.8,25.3-76.42,67.34-76.42,67.34l-27.23-86.79s12.11-.88,29.15-13c11.58-8.22,25.44-21.61,39.31-43.43,34.28-53.91,70.15-65.6,70.15-65.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.63,323.11c-7.86,10.26-22.66,25.19-49.14,39.51-46.8,25.3-76.42,67.34-76.42,67.34l-27.23-86.79s12.11-.88,29.15-13c13.95-.38,38.78,6.06,51.23,26C385.22,356.18,425.75,336.25,457.63,323.11Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.43,326.78s-8.13,13.21-29.14,21.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.52,360.53c-5,2.09-25.72,8.6-30.47,11.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.56,296.67s4.73-17,11.66-27.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.6,310.11s-1.94,5.12-8,13c-7.86,10.26-22.66,25.19-49.14,39.51-46.8,25.3-76.42,67.34-76.42,67.34l-27.23-86.79s12.11-.88,29.15-13c11.58-8.22,25.44-21.61,39.31-43.43,34.28-53.91,70.15-65.6,70.15-65.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.82,371.94l-29.23,3.51s-20.41,6.22-25.34,10.65-11.41,16.31-11.41,16.31-7.18,1.36-10.86,0a3.09,3.09,0,0,1-1.93-1.57,15.39,15.39,0,0,1-1-3.48,45.53,45.53,0,0,1-.16-11.29s-4.8-6.86-5-9.67.82-14.39,3.72-17.63a2.78,2.78,0,0,1,.39-.38c3.2-2.56,21.46-10.68,21.46-10.68s4.11-6.17,14.16-8,31.74,4.57,31.74,4.57l3.15,6.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.07,397.39a45.53,45.53,0,0,1-.16-11.29s-4.8-6.86-5-9.67.82-14.39,3.72-17.63c-3.36,6.7-2.69,16.91,2,13.66,5.71-4,11.6,4.14,11.6,4.14C140,379.83,135.44,390.84,134.07,397.39Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.82,371.94l-29.23,3.51s-20.41,6.22-25.34,10.65-11.41,16.31-11.41,16.31-7.18,1.36-10.86,0c3.38-1,8.28-4.8,9.21-9.89,1.32-7.24,13.51-13.76,13.05-19.37s-9.81-14.76-9.81-14.76c5.48-1.19,10.42,2.22,10.42,2.22a31.43,31.43,0,0,0-7.45-6.54c10.73-1.16,12.79,6.43,12.79,6.43,3,.67,10-2.11,10-2.11a15.06,15.06,0,0,1,2.23-7.69l3.48,5.45c3.79,0,16.51-3.62,22.56-5.41Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,400.88c1.57,3.65,12.78,1.54,12.78,1.54s6.49-11.89,11.42-16.32,25.34-10.66,25.34-10.66l29.23-3.5-13.47-27.63s-21.69-6.39-31.74-4.56-14.16,8-14.16,8-18.26,8.11-21.46,10.68-4.34,15.19-4.11,18,5,9.67,5,9.67S132.76,395.57,135.05,400.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,398.42s1.83-10.27,10.51-14c0,0,.91-6.12-1.37-8.94s-8.91,2.66-9.14,8.94S135.5,398.42,135.5,398.42Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,360.53s15.23,6.84,7.27,23.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,357.33s12.94,11.16,3.43,25.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46,355.06a50.91,50.91,0,0,0,0,14.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.16,372.46s-2.74,1.31-4.57,8.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,360.53s-3.88.53-5.93,8.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,371.94c-3.2,2.05-4.89,6.36-4.89,6.36s.6,7.8,0,9.85-4.94,5.94-8.37,3.77-5.19-10.16-14.07-13.62L278.9,356.18a34.85,34.85,0,0,1,6.68-7.09,54.41,54.41,0,0,1,13.57-8.2c14.44-6.17,32-10.05,40.59-7.31,4.82,1.55,10.63,6.94,15.11,12.25,3.46,4.09,6.12,8.16,6.93,10.35C363.6,361.21,365,369.88,361.78,371.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,371.94c-3.2,2.05-4.89,6.36-4.89,6.36s.6,7.8,0,9.85-4.94,5.94-8.37,3.77-5.19-10.16-14.07-13.62L278.9,356.18a34.85,34.85,0,0,1,6.68-7.09c7.61,0,17.63.72,25.84,4.12,0,0-.56-6.17,2.64-5.47,0,0-.81-6.24,2.64-6.55s2.64,2,2.64,2,0,6.29,2.79,7.56,1.15-7.41,6.51-8.62c0,0,.3,9.78,3.44,12.95,0,0-3.57,10.31,1.3,15.42s14,11.2,16,11S344,372.4,344,372.4s.14-9.07,5.74-10.85,10.47,2.78,10.47,2.78a65.13,65.13,0,0,0-5.32-18.5c3.46,4.09,6.12,8.16,6.93,10.35C363.6,361.21,365,369.88,361.78,371.94Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,356.18s5.81-9.13,20.26-15.29,32-10.05,40.59-7.31,20.21,17.58,22,22.6,3.2,13.7,0,15.76-4.88,6.35-4.88,6.35.6,7.81,0,9.86-4.94,5.94-8.36,3.77-5.2-10.16-14.08-13.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,372.4s.69-8.91,5-8.45,7.59,9.82,7.9,20.43C356.89,384.38,352.19,375.14,344,372.4Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,375.44s-5-16.06,5.7-22.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.63,344.31s-4.14,13.78,0,21.5c0,0-9.78-7.34-17.2-4.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,361.55s-1.41-5.37-1.18-8.33-3.73-6.4-2.21-10.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.05,349.79s3.27,7.44,5.29,8.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.29,367.37s4.12-1.82,7.35,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.1,354.11s6.62-.56,8.22,12.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.78,257.76s-15.93-9.18-2.88-42.35,52.28-43.23,61.15-53.23C314.05,162.18,310.47,264.05,255.78,257.76Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.1,171.7c-4.48,8.51-18.27,19.25-33.42,45.09a235.92,235.92,0,0,0-18.42,40.61c-2.41-1.78-12.16-10.78-4.78-35,.29,8.6,3.34,13.43,3.34,13.43C252.86,202.38,307.1,171.7,307.1,171.7Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.78,257.76s-15.93-9.18-2.88-42.35,52.28-43.23,61.15-53.23C314.05,162.18,310.47,264.05,255.78,257.76Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,216.79s-2.48,17.73,3.22,29.28l2.85-7.39s19.78-.53,30.06-13.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.07,201.76s-4.49,16.61-1.32,28.22l1.32-5.8s24.79-6.42,30.06-14.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.91,191s-6,12.39-5.86,22.68l2.93-5s20.94-4,24.64-10.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.38,180.3c-4.37,6-9.56,19.55-9.56,19.55l4.78-5.44s11.82-3.08,16.24-8.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,345.25s6.8-119.76,64.51-165c0,0-53.54,44.23-56.3,165Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.79,345.25s6.8-119.76,64.51-165c0,0-53.54,44.23-56.3,165Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,345.25s6.8-119.76,64.51-165c0,0-53.54,44.23-56.3,165Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,220.41s14.25-8.21,2.57-37.88-46.76-38.67-54.69-47.61C179.27,134.92,182.47,226,231.39,220.41Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234,182.51a31.41,31.41,0,0,0-2.25-4.63c-1.79-3,2.72,5.89,2.81,13.07a11.88,11.88,0,0,1-4.19,9.49c-.9-4.7-1.39-9.63-3.64-13.86-11.46-21.64-38.22-41.25-42.47-44.48.46.58,15.11,19,23.78,29.6,4.65,5.71,7.74,12.91,10.8,19.54,3.88,8.43,7.36,17,10.81,25.64.48,1.21,1,2.41,1.45,3.61,3.88-2.42,6-6.92,6.9-11.41,1.48-7.67-.28-15.6-2.73-23C234.88,184.87,234.47,183.68,234,182.51Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,220.41s14.25-8.21,2.57-37.88-46.76-38.67-54.69-47.61C179.27,134.92,182.47,226,231.39,220.41Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.07,183.77s2.22,15.85-2.88,26.18l-2.55-6.61s-17.69-.47-26.89-11.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,170.32s4,14.86,1.18,25.24l-1.18-5.19s-22.18-5.74-26.89-12.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.91,160.65s5.36,11.09,5.24,20.29l-2.62-4.49s-18.73-3.54-22-9.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,151.12c3.92,5.41,8.56,17.49,8.56,17.49L202,163.75s-10.57-2.76-14.52-7.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,293.81s-3.7-102.26-55.31-142.76c0,0,49.69,44.51,50.42,159.05,0,0,1.62.32,2.49-2.32",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246,293.81s-3.7-102.26-55.31-142.76c0,0,49.69,44.51,50.42,159.05,0,0,1.62.32,2.49-2.32",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246,293.81s-3.7-102.26-55.31-142.76c0,0,49.69,44.51,50.42,159.05,0,0,1.62.32,2.49-2.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,386.7s-3.44-2.72,0-11.22c2.64-6.51,11.23-6.19,11.7-13,3.52.44,6.33-1.89,8.15-4.74s3.29-6.27,6.33-7.77c1-.46,2-.71,2.92-1.2,3.61-1.92,4.86-7.11,8.76-8.29,2.3-.7,5,.25,7.11-.82s3.15-4,5.44-5a22,22,0,0,1,3-.69c4.05-1.06,6.66-6,10.85-5.89,1.21.05,2.51.54,3.59,0,.85-.42,1.36-1.39,2.24-1.73a4.26,4.26,0,0,1,2.29.09,12.09,12.09,0,0,0,7-.58c2-.91,2.46-3.56,3.68-4.16,4.85-2.39,10.29,6.92,13.1,9.25,1.64,1.37,3.49-2.13,5.62-2.05,1.94.08,2.93,3.08,4.85,2.84-.89.7-.38,2.25.6,2.82a8.14,8.14,0,0,0,3.31.63c2.76.29,5.25,1.74,7.65,3.15a3.09,3.09,0,0,1,1.1.89c.29.44.35,1,.65,1.43.63.89,2.09,1,2.56,1.94a6.7,6.7,0,0,1,.26,1.56c.31,1.48,2.06,2.15,3.57,2.26s3.13-.07,4.42.73a16.17,16.17,0,0,1,2.42,2.47c3,2.91,6.48,2.75,9.25,6.43,2.9,3.85,4.86,8.06,9,10.84,7,4.71,9,11.35,10.91,17.52s-25.22,21.53-80,25.46S161.83,390.86,162.55,386.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.66,344c1.22.32,3,.24,3.15-1a2.61,2.61,0,0,1,.06-.84c.32-.74,1.46-.17,2.25-.35.59-.14.95-.72,1.38-1.14a3.2,3.2,0,0,1,4.09-.2c.69.56,1.15,1.42,1.94,1.82,1.48.74,3.91-.09,4.46,1.46",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.75,351.81a2.7,2.7,0,0,0,4-1.37c.11-.4.15-.87.49-1.12.52-.37,1.22.13,1.86.19,1.27.13,2-1.35,2.83-2.3a4.25,4.25,0,0,1,7.24,1.61l7.54,2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.65,335.93a12.1,12.1,0,0,1,4-.57,2.14,2.14,0,0,1,3.12-2.64,3.05,3.05,0,0,1,4.55.5l.3,1.26a16.53,16.53,0,0,1,5.39,3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.58,345.33l2,.59c-.33-.52.29-1.16.9-1.28a5.26,5.26,0,0,0,1.79-.31c.6-.36.78-1.12,1.17-1.7s1.37-.91,1.7-.3c-.08-.64.63-1.16,1.28-1.14a3.45,3.45,0,0,1,1.77.78l5.12,3.56",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.85,402.41s5.79-10.23,13.4-16.31,13.09-13.89,19.79-22.17,16.44-18.78,21.31-19.62,15.83.73,17.05,10.75c0,0,7.45-9,17.88-2.7s5.25,18.21,5.25,18.21,3.8-1.52,6.16,0,9.08,82.11,9.08,82.11a80.09,80.09,0,0,0-11.28,3.74c-5.78,2.43-13.09,2.74-18,0,0,0-9.13,2.36-15.22,1.94s-22.53-.72-28.31-2.25A117,117,0,0,1,164.43,449a27.31,27.31,0,0,1-10.36-10.49c-1.82-3.7-5.17-4.91-10.35-11.15S145.85,402.41,145.85,402.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.69,370.57c-2.28-1.46-5.9-.1-6.15,0a18,18,0,0,0,1-3.52l-6.25,13.17s-9.67,12.58-13.13,18.22-.5,6.23-4.75,15.21-10.47,26.16-17.05,27.55-20.56-3.39-23.16-10.12,3.67-11.48,11.36-21.23,10.88-13.4,10.27-17.92,15-31.76,16-33.42c-.41.54-2.82,3.77-5.84,7.76a58.25,58.25,0,0,0,3.48-7.84l-14.39-6.06s-14.15,15.06-6.54,20.82c4.18,3.17,8.32,3.22,12.17,0-3,3.93-5.95,7.58-7.6,9.38-4.57,5-5.49,10.55-7.54,13.83s-10.19,16.9-17.21,21.82-11.17,6.27-16.89,3.19c-3.9-2.11-6.32-13.69-7.48-20.82-.73,1.15-1.12,1.85-1.12,1.85s-7.3,18.7-2.12,24.94,8.52,7.45,10.34,11.15A27.51,27.51,0,0,0,164.42,449,118.45,118.45,0,0,0,183,456.12c5.78,1.51,22.22,1.82,28.31,2.24s15.22-1.94,15.22-1.94c4.87,2.74,12.17,2.44,18,0a83.77,83.77,0,0,1,10.27-3.49c.32-.41.62-.84.94-1.27C254.91,442.35,248.9,372,246.69,370.57Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5,358.42S208,375.21,218,382.54s20.83-6.64,21.3-18.21Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.78,452.68l-1,.25a83.77,83.77,0,0,0-10.27,3.49c-5.79,2.44-13.09,2.74-18,0,0,0-9.13,2.37-15.22,1.94s-22.53-.73-28.31-2.24A118.45,118.45,0,0,1,164.42,449a27.51,27.51,0,0,1-10.35-10.5c-1.82-3.7-5.17-4.9-10.34-11.15s2.12-24.94,2.12-24.94.39-.7,1.12-1.85c2-3.23,6.66-10,12.28-14.46,7.61-6.1,13.09-13.89,19.79-22.17s16.44-18.78,21.31-19.62,15.83.73,17.05,10.75c0,0,7.45-9,17.88-2.7,6.83,4.15,7,10.68,6.25,14.68a18,18,0,0,1-1,3.52c.25-.09,3.87-1.45,6.15,0s8.22,71.78,9,81.09C255.74,452.32,255.78,452.68,255.78,452.68Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4,355.06c-3.35,2.72-21.62,37.2-25,41.31s-12.79,15.82-16.9,20.13a50.55,50.55,0,0,0-7.31,10.85,71.72,71.72,0,0,1-8.44,7.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.53,370.57a151.78,151.78,0,0,0-8,15.53c-3,7.07-11.57,25.11-15.14,32s-9.29,22.6-13.4,25.12-10.05,8.22-13.7,7.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,453s-1-2.24,0-2.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,454.1s8.23-7.87,9.37-13.62,17.3-51,17.3-51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,352.36s9.37-.61,14.39,6.06c0,0-7.54,18.77-16.67,14S198.06,352.36,198.06,352.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5,358.42s9.41-.33,16.8,5.91c0,0-4.93,21.08-16.8,17.88S218.61,365.22,222.5,358.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82,376.43s-5.26,7.92-4.57,13.7,8.44,4.71,8.44,4.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,396.37s6.46,4.78,12.71,6.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,405.05s.92,11,3.2,14.84,17.63,3.65,17.63,3.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.09,431.07a24,24,0,0,0,11.19,10.13c8,3.57,13.54,2,13.54,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.45,447.05s12.1,5.55,19.41,1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,378.29s2.58,6,7.8,7.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,416.5a14.84,14.84,0,0,0,9.09,3.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,423.08s-7.31,13.24-15.07,16.9-14.16,2.29-18.72,5-12.33,4.11-22.83,5.94-21.08,4.11-28.58,2.74a26.47,26.47,0,0,1-7.44-2.62,54.57,54.57,0,0,1-13.54-10.58c-3.73-3.83-3.41-10-.9-14.16a8.43,8.43,0,0,1,5.24-4.15s-2.51-2-5.34-4.53c-3.07-2.74-6.49-6.12-7.43-8.26-1.84-4.11-1.38-11.41,5-17.81a18.43,18.43,0,0,1,14.15-5.47s-9.78-8-5.94-17.36c1.39-3.38,3.87-7.85,11.42-9.13,10.81-1.83,16.9,4.34,16.9,4.34s-1.71-10.72,9.19-13S315.42,366,320,368.29c3.29,1.64,8.45,5.4,13.3,8.39l1.16.72c1.34.8,2.65,1.53,3.86,2.11,5.65,4.11,7.36,10.6,10.21,12.41a4.85,4.85,0,0,0,5.2-.28c.19.29.37.57.52.84C356.52,396.59,362,414,344.65,423.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,423.08s-7.31,13.24-15.07,16.9-14.16,2.29-18.72,5-12.33,4.11-22.83,5.94-21.08,4.11-28.58,2.74a26.47,26.47,0,0,1-7.44-2.62c5.67-.43,10-3.27,12-7.53,2.51-5.28-4.95-5.68-6.74-2.34s-12.51,2.14-10.62,0-1.89-13.09-3.88-14.56c-.85-.65-3-.59-5.24-.31a8.43,8.43,0,0,1,5.24-4.15s-2.51-2-5.34-4.53l7,4.15s15,13,23.19,19.4,23.72,4.88,27.8,0-14.43-20.08-20.21-24.7c-5.6-4.46-8.07-11.93-8.21-12.39.49.46,15.64,15.13,24,24.92,8.54,10,17.44,7,27.11,2.49s4.26-17.41,1.17-20.48-16.7-14.89-18.84-18.48-17-16.27-18-17.07c1,.66,17.45,11.31,19.81,14s8.53,7,17.69,13.54,16.11,14.13,22.88,0c4.65-9.72-3.85-20.53-9.61-26.34l1.16.72c1.34.8,2.65,1.53,3.86,2.11,5.65,4.11,7.36,10.6,10.21,12.41a4.85,4.85,0,0,0,5.2-.28c.19.29.37.57.52.84C356.52,396.59,362,414,344.65,423.08Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,381.26a22,22,0,0,1,14.84-13s11.19,7.76,11.19,14.15-4.31,11.34-12.31,8.87S252,381.26,252,381.26Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,365.1s4.58-5.94,11.65-7.76c0,0,14.73,11.19,9.19,17.12S281.17,372.86,278.89,365.1Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,409.14s5.64-8.82,13.93-11.19c0,0,17.13,9.67,8.45,17.28S238.85,413.25,236.79,409.14Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,423.08s-7.31,13.24-15.07,16.9-14.16,2.29-18.72,5-12.33,4.11-22.83,5.94-21.08,4.11-28.58,2.74-14.57-6.63-21-13.2c-5.62-5.78-2.05-16.93,4.34-18.31,0,0-10.95-8.68-12.77-12.79s-1.38-11.41,5-17.81a18.43,18.43,0,0,1,14.15-5.47s-9.78-8-5.94-17.36c1.39-3.38,3.87-7.85,11.42-9.13,10.81-1.83,16.9,4.34,16.9,4.34s-1.71-10.72,9.19-13S315.42,366,320,368.29c3.55,1.78,9.3,6,14.46,9.11,1.34.8,2.65,1.53,3.86,2.11,5.65,4.11,7.36,10.6,10.21,12.41a4.85,4.85,0,0,0,5.2-.28c.19.29.37.57.52.84C356.52,396.59,362,414,344.65,423.08Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.58,364C273.11,367.52,287,380,293,383.66S315.73,405.58,320.6,408s9.13,10.05,14.91,11.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,386.1c8.37,7,17.81,18.87,22.37,22.22s14.92,14.92,19.49,20.7,7.61,9.74,25.57,12.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,423.54s-1.21,11-18,13.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,391.92s4.56,13.05-7.62,17.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82,422.17s11.81,9.89,16.63,12.63,11.22,10.05,16.09,11.57a18.26,18.26,0,0,0,9.74,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9,435.81A18.33,18.33,0,0,1,293,441.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,379.47a21.93,21.93,0,0,1,14.84-13s11.19,7.76,11.19,14.16-4.32,11.33-12.32,8.86S249.21,379.47,249.21,379.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.06,364s4.58-5.94,11.65-7.77c0,0,14.74,11.19,9.19,17.13S279.35,371.71,277.06,364Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,407.56s5.63-8.83,13.93-11.19c0,0,17.12,9.67,8.45,17.28S237.34,411.67,235.28,407.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3,436.2s7.94-1.61,9.89-8.85c0,0,8.12,6.27,3.44,11.15C245.75,445.69,239.3,436.2,239.3,436.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.8,388.15a10.42,10.42,0,0,0,5.25-7.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.42,396.37s-1.77,10-11.5,11.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,419.89s-4,5.79-9.88,7.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6,445.52a15.53,15.53,0,0,1-6.58,5.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.78,447.05a5.14,5.14,0,0,1-1,3.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.41,449a13.07,13.07,0,0,0,9.81-5.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentBro);
export default __webpack_public_path__ + "static/media/Environment-bro.eaede07506bdf9a0baf2920fefbd53b1.svg";
export { ForwardRef as ReactComponent };